/* ===========================================================================
   FLIPSI · ABOUT US
   Behaviour for sections/flipsi-about.liquid.

   Three small things, all of them progressive: without this file the page
   still reads, the videos still show their posters, and the seal's answer is
   simply always open.

     1. .fab-fade   reveal on scroll, once, then unobserved.
     2. videos      muted loops that play only while on screen and stop when
                    they leave, plus a manual pause control whose state wins
                    over the observer. Under prefers-reduced-motion nothing
                    autoplays: posters only, play on demand.
     3. the seal    one collapsible panel, driven by grid-template-rows so it
                    animates without a hardcoded height.

   Everything is namespaced fab- to match the CSS. Scoped to .fab so nothing
   here can touch another section.
   ======================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.fabReady === '1') return;
    root.dataset.fabReady = '1';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- 1. fade in on scroll ------------------------------------------ */
    var fades = root.querySelectorAll('.fab-fade');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('fab-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.08 });
      Array.prototype.forEach.call(fades, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(fades, function (el) { el.classList.add('fab-in'); });
    }

    /* ---- 2. videos ------------------------------------------------------
       NOTE: a backgrounded tab throttles all of this. If a video looks stuck
       at its poster, check the tab is actually in the foreground before
       assuming the file is broken. */
    var vids = root.querySelectorAll('.fab-vcard video');
    if ('IntersectionObserver' in window && !reduced) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (!v.dataset.userPaused) { v.play().catch(function () {}); }
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      Array.prototype.forEach.call(vids, function (v) { vio.observe(v); });
    }

    Array.prototype.forEach.call(root.querySelectorAll('.fab-vpause'), function (btn) {
      var v = btn.parentElement.querySelector('video');
      if (!v) return;
      btn.addEventListener('click', function () {
        if (v.paused) {
          delete v.dataset.userPaused;
          v.play().catch(function () {});
          btn.textContent = '❚❚';
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          v.dataset.userPaused = '1';
          v.pause();
          btn.textContent = '▶';
          btn.setAttribute('aria-label', 'Play video');
        }
      });
      if (reduced) {
        btn.textContent = '▶';
        btn.setAttribute('aria-label', 'Play video');
      }
    });

    /* ---- 3. the seal ---------------------------------------------------- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-fc]'), function (fcEl) {
      var btn = fcEl.querySelector('.fab-seal-btn');
      var panel = fcEl.querySelector('.fab-fc-panel');
      if (!btn || !panel) return;

      var setFocusable = function (open) {
        Array.prototype.forEach.call(panel.querySelectorAll('a,button'), function (el) {
          if (open) { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', '-1'); }
        });
      };
      var setOpen = function (open) {
        fcEl.classList.toggle('fab-open', open);
        btn.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
        setFocusable(open);
      };

      setOpen(false);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setOpen(!fcEl.classList.contains('fab-open'));
      });
      var cl = fcEl.querySelector('.fab-fc-close');
      if (cl) {
        cl.addEventListener('click', function (e) {
          e.stopPropagation();
          setOpen(false);
          btn.focus();
        });
      }
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.fab'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.fab');
    if (el) init(el);
  });
})();
